// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1IoFE","question":"Question_question__1K9MY","description":"Question_description__1oT64"};